import Carousel from '../Carousel';
import { CollectionsProps } from '../Collections';
import { Collection } from '../types';

interface CollectionsHeaderProps {
  title: string;
  subtitle: string;
  collections?: Collection[];
}

function getCarouselItems(
  arr: CollectionsProps['collections'],
  count: number
): CollectionsProps['collections'] {
  if (!arr) return [];
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

export const CollectionsHeader = ({
  title,
  subtitle,
  collections,
}: CollectionsHeaderProps) => {
  const carouselItems = getCarouselItems(collections, 3);

  return (
    <header className="lg:flex lg:items-center mb-10">
      <div className="mb-8 lg:mb-0 lg:mr-24">
        <h1 className="text-2xl font-black">{title}</h1>
        <p className="text-sm text-gray-500 font-medium">{subtitle}</p>
      </div>
      <aside className="flex-1 ml-auto max-w-6xl">
        <Carousel items={carouselItems} />
      </aside>
    </header>
  );
};
